import { useQuery } from '@tanstack/react-query'
import { api } from 'api'

export const useFetchRef = (dataCustomer: any) => {
  return useQuery({
    queryKey: ['referralRef', dataCustomer],
    queryFn: () => api.referral.fetchRef(dataCustomer),
    enabled: false, // Запрос выполняется только по требованию
  })
}
